import React from 'react';
import cx from 'classnames';
function Index({
  step = 1,
  typebatch
}) {
  return <ul data-public className="steps">
      <li className={cx(step >= 1 ? 'active' : '', 'text-left')}>Pending</li>
      <li className={step >= 2 ? 'active' : ''}>Matched</li>
      <li className={step >= 4 ? 'active' : ''}>Project Activated</li>
      <li className={step >= 5 ? 'active' : ''}>Complete</li>
      {typebatch === 'standard' ? <li className={step >= 6 ? 'active' : ''}>Closed</li> : ''}
    </ul>;
}
export default Index;